import React, { useEffect } from "react";
import Modal from "../../common-components/Modal";
import TertiaryButton from "../../common-components/Buttons/TertiaryButton";
import PrimaryButton from "../../common-components/Buttons/PrimaryButton";
import useGetDoctorStaticById from "./hooks/useGetDoctorStaticById";
import { useTranslation } from 'react-i18next';
import ListLoader from "../../common-components/ListLoader";

const ViewDoctorStaticModal = ({
  isOpen = false,
  setIsOpen = () => {},
  docId = null,
  onEdit = () => {},
}) => {
  const { t } = useTranslation();
  const { doctorStatic, isDoctorStaticLoading, getDoctorStaticById } = useGetDoctorStaticById();

  useEffect(() => {
    if (isOpen && docId) {
      getDoctorStaticById(docId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, docId]);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      showModal={isOpen}
      onClose={handleClose}
      modalHeight="h-[90%]"
      modalWidth="w-[80%]"
    >
      <div className="p-5 overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">
          {t("Doctor Information Details")}
        </h2>
      {isDoctorStaticLoading ? (
        <div className="py-8">
          <ListLoader />
        </div>
      ) : doctorStatic ? (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("EMP Code")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.EMP_CODE || "--"}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Doctor Name")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.doctor_name || "--"}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Department")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.department_name || "--"}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Designation")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.designation_name || "--"}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Qualifications")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.qualifications || "--"}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Experience (Years)")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.experience_years !== undefined ? `${doctorStatic.experience_years} ${t("years")}` : "--"}
              </div>
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Languages")}
              </label>
              <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                {doctorStatic.languages || "--"}
              </div>
            </div>

            {doctorStatic.photo_url && (
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("Photo")}
                </label>
                <div className="mt-2">
                  <img
                    src={doctorStatic.photo_url}
                    alt={doctorStatic.doctor_name || "Doctor Photo"}
                    className="w-32 h-32 object-cover rounded-md border border-gray-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <TertiaryButton
              buttonName={t("Close")}
              onClick={handleClose}
            />
            {onEdit && (
              <PrimaryButton
                buttonName={t("Edit")}
                onClick={() => {
                  if (doctorStatic) {
                    onEdit(doctorStatic);
                    handleClose();
                  }
                }}
                disabled={isDoctorStaticLoading}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="py-8 text-center text-gray-500">
          {t("No doctor information found")}
        </div>
      )}
      </div>
    </Modal>
  );
};

export default ViewDoctorStaticModal;

